import {
  DigitalBusinessDocument,
  DigitalCostDocument,
} from "../types/documents";
import { AccountingEvent, AccountingEventsGroup } from "../types/events";
import { CanonicalBusinessEvent } from "../types/cbes";

export const isAccountingEventsGroup = (
  data:
    | AccountingEventsGroup
    | DigitalBusinessDocument
    | DigitalCostDocument
    | CanonicalBusinessEvent
): data is AccountingEventsGroup => "accountingEvents" in data;

export const isDigitalCostDocument = (
  data:
    | AccountingEventsGroup
    | DigitalBusinessDocument
    | DigitalCostDocument
    | CanonicalBusinessEvent
): data is DigitalCostDocument =>
  "documentType" in data && data.documentType === "DigitalCostDocument";

export const isDigitalBusinessDocument = (
  data:
    | AccountingEventsGroup
    | AccountingEvent
    | DigitalBusinessDocument
    | DigitalCostDocument
    | CanonicalBusinessEvent
): data is DigitalBusinessDocument =>
  "documentType" in data && data.documentType !== "DigitalCostDocument";

export const isDigitalDocument = (
  data:
    | AccountingEventsGroup
    | DigitalBusinessDocument
    | DigitalCostDocument
    | CanonicalBusinessEvent
): data is DigitalBusinessDocument | DigitalCostDocument =>
  "documentType" in data;

export const isCanonicalBusinessEvent = (
  data:
    | AccountingEventsGroup
    | DigitalBusinessDocument
    | DigitalCostDocument
    | CanonicalBusinessEvent
): data is CanonicalBusinessEvent => {
  return "records" in data && !isAccountingEventsGroup(data);
};

export const isDocumentFlowEvent = (
  event: AccountingEventsGroup | DigitalBusinessDocument | DigitalCostDocument
): boolean => {
  return "documentType" in event;
};

export const isDocumentFlowCbe = (cbe: CanonicalBusinessEvent): boolean => {
  return Boolean(
    cbe.pk && typeof cbe.pk === "string" && cbe.pk.includes("-document")
  );
};

export const getEventVersion = (
  event: AccountingEventsGroup | DigitalBusinessDocument | DigitalCostDocument
): number => {
  if (isDocumentFlowEvent(event)) {
    return (event as DigitalBusinessDocument | DigitalCostDocument).version;
  }
  return (event as AccountingEventsGroup).sk;
};
